import fallbackLogo from '@/assets/logo.svg';
import { getOrgSlugFromHostname } from '@/core/domain';
import { useEffect, useMemo, useState } from 'react';

interface AuthLogoProps {
  className?: string;
}

export const AuthLogo = ({ className = 'size-16 mb-6' }: AuthLogoProps) => {
  const [src, setSrc] = useState(fallbackLogo);

  const brandingUrl = useMemo(() => {
    const slug = getOrgSlugFromHostname();
    const resourcesEndpoint = import.meta.env.VITE_RESOURCES_ENDPOINT;
    if (!slug || !resourcesEndpoint) return null;
    return `${resourcesEndpoint}/${slug}/logo.png`;
  }, []);

  useEffect(() => {
    if (!brandingUrl) {
      setSrc(fallbackLogo);
      return;
    }

    let cancelled = false;
    fetch(brandingUrl, { method: 'HEAD' })
      .then((response) => {
        if (!cancelled) setSrc(response.ok ? brandingUrl : fallbackLogo);
      })
      .catch(() => {
        if (!cancelled) setSrc(fallbackLogo);
      });

    return () => {
      cancelled = true;
    };
  }, [brandingUrl]);

  return <img src={src} alt='Logo' className={className} onError={() => setSrc(fallbackLogo)} />;
};
